import React, { useMemo } from "react";

import Button from "components/atoms/Button";
import { useHistory, useLocation } from "react-router-dom";
import { Wrapper, Content, Heading, Details, ButtonWrapper } from "./styles";

const PaymentSuccess = () => {
  const history = useHistory();

  const location = useLocation<{ type: string }>();

  const query = new URLSearchParams(location.search);
  const type = query.get("type");

  const description = useMemo(() => {
    if (type) {
      if (type.includes("clarity")) {
        return `Your payment was successful. When you finish all your assessments you will receive an email with link to book your Clarity Session. Click the button below to return to the dashboard.`;
      }
      if (type.includes("guidance")) {
        return `Your payment was successful. When you finish all your assessments you will receive an email with link to book your Guidance Session. Click the button below to return to the dashboard.`;
      }
      return `Your payment was successful. Click the button below to return to the dashboard to finish assessments.`;
    }
    return "";
  }, [type]);

  const moveToDashboard = () => history.push("/student");

  return (
    <Wrapper>
      <Content type="success">
        <Heading>Success!</Heading>
        <Details>{description}</Details>
        <ButtonWrapper>
          <Button variant="primary" onClick={moveToDashboard}>
            OK
          </Button>
        </ButtonWrapper>
      </Content>
    </Wrapper>
  );
};

export default PaymentSuccess;
